import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Poppins, sans-serif', // Correct syntax for fontFamily
    },
    spacing: 8,
    components: {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    fontWeight: 600, // Use this for the active tab font weight
                },
            },
        },
    },
});

export default theme;
